import * as React from "react";
const SvgKeyboardDoubleArrowUp = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z",
  fill: "currentColor"
}));
export default SvgKeyboardDoubleArrowUp;